export const colors = {
    primary: '#252525',
    accent: '#ba9b5d',
    lightGray: '#525252'
}
export const column = {
    left: 2,
    right: 5
}
export const avatarSize = 160